// extracted by mini-css-extract-plugin
export default {"main":"main_main__fUIai","header":"main_header__MTsVo"};